import { createActionTypes } from '../../../state/actions'

export const FETCH_ADMIN = createActionTypes('FETCH_ADMIN')

export const fetchAdmin = (payload) => ({
  type: FETCH_ADMIN.action,
  payload,
})

export const fetchAdminSuccess = (payload) => ({
  type: FETCH_ADMIN.success,
  payload,
})

export const fetchAdminFailed = (error) => ({
  type: FETCH_ADMIN.failed,
  error,
})
